import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bb9e1584"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "row"
};
const _hoisted_2 = {
  class: "col-lg-4 col-12"
};
const _hoisted_3 = {
  class: "referrals-card"
};
const _hoisted_4 = {
  class: "mb-2"
};
const _hoisted_5 = {
  class: "fw-bold"
};
const _hoisted_6 = {
  class: "fw-extra-bold text-primary"
};
const _hoisted_7 = {
  class: "fsi-24"
};
const _hoisted_8 = {
  class: "fw-extra-bold text-primary"
};
const _hoisted_9 = {
  key: 0,
  class: "mt-2"
};
const _hoisted_10 = {
  class: "fsi-14"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "1px",
    "background-color": "#ececec"
  },
  class: "mb-3 mt-3"
}, null, -1));
const _hoisted_12 = {
  class: "mt-3"
};
const _hoisted_13 = {
  class: "fw-bold"
};
const _hoisted_14 = {
  class: ""
};
const _hoisted_15 = {
  class: "fw-extra-bold text-primary"
};
const _hoisted_16 = {
  class: "fsi-24"
};
const _hoisted_17 = {
  class: "fw-extra-bold text-primary"
};
const _hoisted_18 = {
  class: ""
};
const _hoisted_19 = {
  class: ""
};
const _hoisted_20 = {
  class: "fw-extra-bold text-primary"
};
const _hoisted_21 = {
  key: 0,
  class: "mt-3"
};
const _hoisted_22 = {
  class: "col-lg-8 col-12 pl-lg-2"
};
const _hoisted_23 = {
  class: "row"
};
const _hoisted_24 = {
  class: "col-md-6 col-12 mt-lg-0 mt-3 referrals-col-spacing referrals-col-spacing-left"
};
const _hoisted_25 = {
  class: "referrals-card"
};
const _hoisted_26 = {
  class: "d-flex justify-content-between align-items-center"
};
const _hoisted_27 = {
  class: "fw-bold"
};
const _hoisted_28 = {
  class: "col-md-6 col-12 mt-lg-0 mt-3 referrals-col-spacing referrals-col-spacing-right"
};
const _hoisted_29 = {
  class: "referrals-card position-relative"
};
const _hoisted_30 = {
  class: "fw-bold"
};
const _hoisted_31 = {
  key: 0,
  style: {
    "position": "absolute",
    "right": "1rem",
    "top": "1.2rem"
  }
};
const _hoisted_32 = {
  class: "row mt-3"
};
const _hoisted_33 = {
  class: "col-12"
};
const _hoisted_34 = {
  class: "referrals-card",
  style: {
    "padding-top": "1rem",
    "padding-bottom": "1rem"
  }
};
const _hoisted_35 = {
  class: "mb-3 d-flex justify-content-between align-items-center"
};
const _hoisted_36 = {
  class: "fsi-18 fw-bold text-left"
};
const _hoisted_37 = {
  class: "d-flex justify-content-start align-items-center align-content-center"
};
const _hoisted_38 = {
  style: {
    "width": "30%"
  },
  class: "text-left fs-12"
};
const _hoisted_39 = {
  style: {
    "width": "30%"
  },
  class: "text-left fs-12"
};
const _hoisted_40 = {
  style: {
    "width": "20%"
  },
  class: "text-left fs-12"
};
const _hoisted_41 = {
  style: {
    "width": "20%"
  },
  class: "text-center fs-12"
};
const _hoisted_42 = {
  class: "mt-3"
};
const _hoisted_43 = {
  class: "d-flex justify-content-start align-items-center align-content-center"
};
const _hoisted_44 = {
  style: {
    "width": "30%"
  },
  class: "text-left fsi-14"
};
const _hoisted_45 = {
  key: 0
};
const _hoisted_46 = {
  key: 1,
  class: "fs-12"
};
const _hoisted_47 = {
  style: {
    "width": "30%"
  },
  class: "text-left fsi-14"
};
const _hoisted_48 = {
  style: {
    "width": "20%"
  },
  class: "text-left fsi-14"
};
const _hoisted_49 = {
  style: {
    "width": "20%"
  },
  class: "text-center fsi-14"
};
const _hoisted_50 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center mt-4"
};
const _hoisted_51 = {
  key: 0,
  class: "text-center mb-2 mt-3"
};
const _hoisted_52 = {
  class: "fs-12 opacity-06"
};
const _hoisted_53 = {
  class: "row mt-3"
};
const _hoisted_54 = {
  class: "col-12"
};
const _hoisted_55 = {
  class: "referrals-card",
  style: {
    "padding-top": "1rem",
    "padding-bottom": "1rem"
  }
};
const _hoisted_56 = {
  class: "mb-3"
};
const _hoisted_57 = {
  class: "fsi-18 fw-bold text-left"
};
const _hoisted_58 = {
  key: 0
};
const _hoisted_59 = {
  class: "d-flex justify-content-start align-items-center align-content-center"
};
const _hoisted_60 = {
  style: {
    "width": "30%"
  },
  class: "text-left fs-12"
};
const _hoisted_61 = {
  style: {
    "width": "30%"
  },
  class: "text-left fs-12"
};
const _hoisted_62 = {
  style: {
    "width": "20%"
  },
  class: "text-left fs-12"
};
const _hoisted_63 = {
  style: {
    "width": "20%"
  },
  class: "text-center fs-12"
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_65 = {
  class: "d-flex justify-content-start align-items-center align-content-center"
};
const _hoisted_66 = {
  style: {
    "width": "30%"
  },
  class: "text-left fsi-14"
};
const _hoisted_67 = {
  style: {
    "width": "30%"
  },
  class: "text-left fsi-14"
};
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20%"
  },
  class: "text-left fsi-14"
}, " 0.01FIL ", -1));
const _hoisted_69 = {
  style: {
    "width": "20%"
  },
  class: "text-center fsi-14"
};
const _hoisted_70 = {
  key: 0
};
const _hoisted_71 = {
  key: 1,
  class: "flex-center"
};
const _hoisted_72 = {
  class: "ml-1"
};
const _hoisted_73 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center mt-4"
};
const _hoisted_74 = {
  key: 1,
  class: "text-center mb-3"
};
const _hoisted_75 = {
  class: "fs-12 opacity-06"
};
const _hoisted_76 = {
  class: "mt-2"
};
const _hoisted_77 = {
  style: {
    "color": "#f81515"
  },
  class: "fs-12"
};
const _hoisted_78 = {
  class: "mt-3"
};
const _hoisted_79 = {
  class: "d-flex justify-content-between mb-2"
};
const _hoisted_80 = {
  style: {
    "color": "#f81515"
  },
  class: "fs-12"
};
const _hoisted_81 = {
  class: "mt-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_EditPen = _resolveComponent("EditPen");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_SuccessFilled = _resolveComponent("SuccessFilled");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('Referrals.Your Active Referral Code')), 1), _createElementVNode("div", null, [_createVNode(_component_i_skeleton, {
    loading: _ctx.myInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%",
        "height": "30px",
        "font-size": "24px"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.myReferral === '' ? 'No Code' : _ctx.myReferral), 1), !_ctx.isConnected || _ctx.isRemote === false || _ctx.myReferral === '' ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "ml-2 d-inline-block cursor-pointer",
      style: {
        "transform": "translateY(2px)"
      },
      onClick: _cache[0] || (_cache[0] = (...args) => $options.setYourReferralCode && $options.setYourReferralCode(...args))
    }, [_createVNode(_component_el_icon, {
      size: "22"
    }, {
      default: _withCtx(() => [_createVNode(_component_EditPen)]),
      _: 1
    })])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])]), _createVNode(_component_i_skeleton, {
    loading: _ctx.myInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%",
        "height": "50px",
        "font-size": "24px"
      }
    })])]),
    default: _withCtx(() => [_ctx.myReferral === '' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('Referrals.Your Active Referral Code Tip')), 1)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"]), _hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('Referrals.Your Rebates Rate')), 1)]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_i_skeleton, {
    loading: _ctx.myInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%",
        "height": "26px",
        "font-size": "24px"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.superiorRatio) + "%", 1)]),
    _: 1
  }, 8, ["loading"])]), _createVNode(_component_i_skeleton, {
    loading: _ctx.myInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%",
        "height": "26px",
        "font-size": "24px"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('nft.From')) + " " + _toDisplayString(_ctx.myReferral === '' ? '--' : _ctx.$t($data.LeveLabel[_ctx.supLevel])), 1)])]),
    _: 1
  }, 8, ["loading"]), _createVNode(_component_i_skeleton, {
    loading: _ctx.myInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%",
        "height": "50px",
        "font-size": "24px"
      }
    })])]),
    default: _withCtx(() => [!_ctx.isConnected || _ctx.isRemote === false || _ctx.myReferral === '' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_el_button, {
      class: "btn btn-primary w-100 i-button",
      onClick: $options.setYourReferralCode,
      style: {
        "border-radius": "10px!important"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Referrals.Enter Referral Code')), 1)]),
      _: 1
    }, 8, ["onClick"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('Referrals.Total Interest')), 1)]), _createElementVNode("div", null, _toDisplayString($options.formatWalletFilPrice(_ctx.interest, 4, false, false, true)), 1)])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('Referrals.Total Rebates')) + "/" + _toDisplayString(_ctx.$t('Referrals.Can withdraw')), 1), !_ctx.myInfoLoading ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_el_button, {
    disabled: _ctx.withdrawn <= 0n,
    class: "btn btn-success reward-button",
    loading: _ctx.addWithdrawLoading,
    round: "",
    onClick: $options.withdraw
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Referrals.Withdraw commission')), 1)]),
    _: 1
  }, 8, ["disabled", "loading", "onClick"])])) : _createCommentVNode("", true)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.myInfoLoading
  }, {
    template: _withCtx(() => [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "50%",
        "font-size": "24px"
      }
    })]),
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($options.formatWalletFilPrice(_ctx.discount, 4, false, false, false)) + " / " + _toDisplayString($options.formatWalletFilPrice(_ctx.withdrawn, 4, false, false, true)), 1)]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('Referrals.Rewards Distribution History')), 1)])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Referrals.Settlement Period')), 1)]), _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('Referrals.Current Interest')), 1), _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('Referrals.Discount Rate')), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('Referrals.Rebate Amount')), 1)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.snapshootList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "mb-3"
    }, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [item.start_time !== null ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString($options.simpleDateFormatByMin(new Date(item.start_time).getTime())) + " - " + _toDisplayString($options.simpleDateFormatByMin(new Date(item.end_time).getTime())), 1)) : _createCommentVNode("", true), item.start_time === null ? (_openBlock(), _createElementBlock("span", _hoisted_46, [_createTextVNode(_toDisplayString(_ctx.$t('nft.Next epoch')) + ": ", 1), _createElementVNode("span", null, _toDisplayString(_ctx.nextEpochShow), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_47, [_createElementVNode("span", null, _toDisplayString($options.formatWalletFilPrice(item.interest, 4, false, false)), 1)]), _createElementVNode("div", _hoisted_48, [_createElementVNode("span", null, _toDisplayString(parseInt(item.superior_ratio) / 100) + "% ", 1)]), _createElementVNode("div", _hoisted_49, [_createElementVNode("span", null, _toDisplayString($options.formatWalletFilPrice(item.amount, 4, false, false)), 1)])])]);
  }), 128)), _ctx.withdrawHistoryTotal > 10 ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_createVNode(_component_el_pagination, {
    onCurrentChange: $options.changeSnapshoot,
    layout: "prev, pager, next",
    total: _ctx.withdrawHistoryTotal
  }, null, 8, ["onCurrentChange", "total"])])) : _createCommentVNode("", true)])), [[_directive_loading, _ctx.snapshootInfoLoading]])]), !_ctx.snapshootList || _ctx.snapshootList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t('Referrals.No settlement record')), 1)])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('Referrals.WithdrawRecord')), 1)]), _ctx.withdrawHistory && _ctx.withdrawHistory.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Referrals.WithdrawTime')), 1)]), _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('Referrals.WithdrawAmount')), 1), _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t('Referrals.Fee')), 1), _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('Referrals.WithdrawStatus')), 1), _hoisted_64]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.withdrawHistory, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "mt-3"
    }, [_createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("span", null, _toDisplayString($options.simpleDateFormatByMin(new Date(item.create_time).getTime())), 1)]), _createElementVNode("div", _hoisted_67, [_createElementVNode("span", null, _toDisplayString(item.withdrawn === 0 ? '--' : $options.formatWalletFilPrice(item.withdrawn, 4, false)), 1)]), _hoisted_68, _createElementVNode("div", _hoisted_69, [item.status.toString() === '0' ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(_ctx.$t('Referrals.WithdrawStatus_0')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_71, [_createVNode(_component_el_icon, {
      size: "16"
    }, {
      default: _withCtx(() => [_createVNode(_component_SuccessFilled, {
        color: "#39dccf"
      })]),
      _: 1
    }), _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('Referrals.WithdrawStatus_1')), 1)]))])])]);
  }), 128)), _ctx.withdrawHistoryTotal > 10 ? (_openBlock(), _createElementBlock("div", _hoisted_73, [_createVNode(_component_el_pagination, {
    onCurrentChange: $options.changeWithdraw,
    layout: "prev, pager, next",
    total: _ctx.withdrawHistoryTotal
  }, null, 8, ["onCurrentChange", "total"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !_ctx.withdrawHistory || _ctx.withdrawHistory.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_74, [_createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.$t('Referrals.No Withdraw Distribution History yet')), 1)])) : _createCommentVNode("", true)])), [[_directive_loading, _ctx.withdrawHistoryLoading]])])])])]), _createVNode(_component_el_dialog, {
    modelValue: $data.showSetYourReferralCode,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.showSetYourReferralCode = $event),
    title: _ctx.$t('Referrals.Enter Referral Code'),
    top: "15%",
    width: "350",
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    class: "show-generate-code-dialog",
    "before-close": $options.closeShowSetYourReferralCode
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_input, {
      disabled: $data.checkReferralsCodeLoading,
      style: {
        "height": "45px"
      },
      modelValue: $data.referralCode,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.referralCode = $event),
      onInput: $options.inputReferralCode,
      ref: "generateCodeInput",
      placeholder: _ctx.$t('Referrals.GenerateCodeInput')
    }, null, 8, ["disabled", "modelValue", "onInput", "placeholder"])]), _createElementVNode("div", _hoisted_76, [_createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.referralCodeErrTips), 1)]), _createElementVNode("div", _hoisted_78, [!$data.generateCodeFinish ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      class: "btn btn-primary w-100 i-button",
      disabled: !$data.generateCodeFinish
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($data.referralCodeButtonTips === '' ? _ctx.$t('Referrals.GenerateCodeInputBtn') : $data.referralCodeButtonTips), 1)]),
      _: 1
    }, 8, ["disabled"])) : _createCommentVNode("", true), $data.generateCodeFinish ? (_openBlock(), _createBlock(_component_el_button, {
      key: 1,
      class: "btn btn-primary w-100 i-button",
      onClick: $options.applyReferralsCode,
      loading: $data.checkReferralsCodeLoading
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Referrals.Setting')), 1)]),
      _: 1
    }, 8, ["onClick", "loading"])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["modelValue", "title", "before-close"]), _createVNode(_component_el_dialog, {
    modelValue: $data.showWhileAddressInput,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.showWhileAddressInput = $event),
    title: _ctx.$t('Referrals.NFT whitelist address'),
    top: "15%",
    width: "375",
    class: "show-generate-code-dialog",
    "before-close": $options.whileAddressInputHandleClose
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_79, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_80, _toDisplayString($data.addWhileListErrTips), 1)]), _createVNode(_component_el_button, {
      onClick: $options.setCurrentWallet,
      size: "small",
      round: ""
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Operator.Current Wallet')), 1)]),
      _: 1
    }, 8, ["onClick"])]), _createVNode(_component_el_input, {
      style: {
        "height": "45px",
        "font-size": "12px"
      },
      modelValue: $data.whiteAddress,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.whiteAddress = $event),
      onInput: _cache[4] || (_cache[4] = $event => $data.addWhileListErrTips = ''),
      ref: "whiteAddressInput",
      placeholder: _ctx.$t('Referrals.Enter the address to get the NFT')
    }, null, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_81, [_createVNode(_component_el_button, {
      class: "btn btn-primary w-100 i-button",
      loading: $data.whiteAddressLoading,
      onClick: $options.addWhileList
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Referrals.Submit')), 1)]),
      _: 1
    }, 8, ["loading", "onClick"])])]),
    _: 1
  }, 8, ["modelValue", "title", "before-close"])]);
}